import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { ErrorState, Skeleton } from '@liftango/ui-elements';
import { opsSpace } from '../../../../../theme/opsTokens';
import type { ReportSource, RunReport } from '../useRunReport';

const ROW_SKELETON = { width: '100%', height: '20px' } as const;

/** The first failed source's error with a retry, or a loading placeholder while they load. */
export function SourceProblem({ report, sources }: { report: RunReport; sources: readonly ReportSource[] }) {
  const { t } = useTranslation('simulation');
  const failed = sources.find((source) => report[source].status === 'error');
  if (failed) {
    return <ErrorState title={t(`results.report.errors.${failed}`)} onRetry={() => report.retry(failed)} retryLabel={t('results.report.retry')} />;
  }
  return (
    <Box sx={{ display: 'grid', gap: opsSpace[2], p: opsSpace[3] }} aria-busy="true">
      <Skeleton {...ROW_SKELETON} aria-label={t('results.report.loading')} />
      <Skeleton {...ROW_SKELETON} />
    </Box>
  );
}
